import translate from '../tools/translate';
import Stores from './Stores';
import api from '../../api';
import { FeaturePermission } from '../../../constants/feature.permission.helper';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const types = {
    // stores: (area, type) => new Stores(area, type),
    default: (area, type) => new Stores(area, type)
};

const Factory = (type, area) => {
    const constructor = types.default;
    return constructor(area, type);
};

Factory.getAvailableOptions = () => {
    const options = [];

    if (isAuthorized('Direct-sales-filters-sale-type')) {
        options.push({
            value: 'retail',
            text: translate('Common.RetailSales')
        });
    }

    options.push({
        value: 'directSales',
        text: translate('Common.DirectSales')
    });

    return options;
};

Factory.getMulticriteriaOptions = () => {
    const options = [];

    if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.export)) {
        options.push({
            value: 'multicriteriaAfterSales',
            text: 'Exportar Multicritério',
        });
    }

    return options;
};

export default Factory;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/SelectionTypeFactory.js